import React from "react";
import BrowserViewGlobal from "./BrowserView";
import VideoPlayer from "../players/VideoPlayer";
import ActionPointHandler from "../ActionPoint/ActionPointHandler";
import ChatWrapper from "../Chat/ChatWrapper";
import HTMLRenderer from "../library/HTMLRenderer";
import Navigation from "../Navigation/Navigation";
import hasContent from "../../util/hasContent";
import { useContext } from "react";
import { AudioAppContext } from "../../contexts/AudioContext";

export default function EventBrowserInitView({
  mainPage,
  event,
  children = null,
}) {
  const { videoMuted, setVideoMuted } = useContext(AudioAppContext);

  function handleVideoSound(event) {
    if ( event.target.className === "view__links" && (mainPage.backgroundVideoFile || mainPage.backgroundVideoLink)) {
      setVideoMuted(!videoMuted);
    }
  }

  return (
    <BrowserViewGlobal>
      <Navigation />
      <div className="wrap" onClick={handleVideoSound}>
        <div>
          <div className="view">
            {(mainPage.heading || hasContent(mainPage.description)) && (
              <div className="view__info">
                {mainPage.heading && <h2>{mainPage.heading}</h2>}
                {hasContent(mainPage.description) && (
                  <HTMLRenderer html={mainPage.description} />
                )}
              </div>
            )}
            {children ? children() : <VideoPlayer {...mainPage} />}
          </div>
        </div>

        {mainPage.actionPoints && (
          <ActionPointHandler
            actionInfo={{
              header: mainPage.heading,
              description: mainPage.description,
            }}
            actionPoints={mainPage.actionPoints}
          />
        )}
        <ChatWrapper
          {...{
            event,
            page: mainPage?.slug,
            showPublicChat: mainPage?.showPublicChat,
            showCorporateChat: mainPage?.showCorporateChat,
            corporateOrganization: mainPage?.corporateOrganization,
          }}
        />
      </div>
    </BrowserViewGlobal>
  );
}
